import { LocalStorage } from '@src/lib/local-storage'
import { appConfig } from '@src/config'

const storageKey = appConfig.storageKey as string

/** 取得 Token */
export function getToken() {
  const token = LocalStorage.getItem<string>(storageKey)
  return token
}

/** 設定 Token */
export function setToken(token: string) {
  LocalStorage.setItem(storageKey, token)
}

/** 移除 Token */
export function removeToken() {
  LocalStorage.removeItem(storageKey)
}
